module.exports = __webpack_public_path__ + "img/privacy_office.356f83b8.webp";